const MIME_EXTENSION_MAP: Record<string, string> = {
    'audio/webm': 'webm',
    'audio/webm;codecs=opus': 'webm',
    'audio/ogg': 'ogg',
    'audio/ogg;codecs=opus': 'ogg',
    'audio/mp4': 'mp4',
    'audio/mpeg': 'mp3',
    'audio/wav': 'wav',
}

const CSRF_COOKIE = '_eid_csrf_v1'
const CSRF_HEADER = 'X-CSRF-Token'

function extensionFromMime(mime: string): string {
    return MIME_EXTENSION_MAP[mime] || 'webm'
}

export function buildTranscribeRequest(audioBlob: Blob, language?: string): FormData {
    const formData = new FormData()
    formData.append(
        'file',
        audioBlob,
        `recording.${extensionFromMime(audioBlob.type)}`,
    )
    if (language) formData.append('language', language)
    return formData
}

export function csrfHeaders(): Record<string, string> {
    if (typeof document === 'undefined') return {}
    const match = document.cookie.match(
        new RegExp(`(?:^|;\\s*)${CSRF_COOKIE}=([^;]+)`),
    )
    const token = match ? decodeURIComponent(match[1]) : undefined
    return token ? { [CSRF_HEADER]: token } : {}
}

export function friendlyTranscriptionError(status: number, detail?: string): string {
    if (detail) {
        if (detail.startsWith('unsupported_audio_type')) {
            return 'Audio format not supported — try a different browser'
        }
        if (detail === 'transcription_concurrency_limit') {
            return 'Too many requests — please wait a moment'
        }
        if (detail === 'file_required') return 'No audio was captured — please try again'
        if (detail === 'file_too_large') return 'Recording too large (max 25 MB)'
        if (detail === 'transcription_rate_limit') {
            return 'Rate limit reached — please wait a moment'
        }
    }
    if (status === 401 || status === 403) return 'Session expired — please refresh the page'
    if (status === 415) return 'Audio format not supported'
    if (status === 429) return 'Too many requests — try again shortly'
    if (status >= 500) return 'Server error — please try again later'
    return `Transcription failed (${status})`
}
